<template>
  <div
    v-if="shouldShowRateLimit"
    class="rate-limit-widget-component"
    :style="containerStyles"
  >
    <div class="action-text">
      <span class="questions-remaining">{{ questionsRemaining }}</span>
      <span class="questions-text">{{ questionsText }}</span>
    </div>
    <button
      class="action-button"
      :class="{ 'no-credits-left': questionsRemaining === 0 }"
      @click="handleActionButtonClick"
    >
      <icon
        class="button-icon"
        :name="iconName"
        :variant="'white'"
      />
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon.vue';
import RateLimitMixin from '@/mixins/rate-limit';

export default {
  name: 'RateLimitWidget',
  components: {Icon},
  mixins: [RateLimitMixin],
  props: {
    config: {
      type: Object,
    },
    dashboard: {
      type: Object,
    },
  },
  computed: {
    backgroundAttachment() {
      if (this.jsonConfig?.backgroundAttachmentId) {
        return this.$store.getters['attachments/get'][this.jsonConfig.backgroundAttachmentId];
      }
    },
    buttonText() {
      if (this.questionsRemaining > 0) {
        return this.jsonConfig?.resumeButtonText || 'Answer More...';
      }

      return this.jsonConfig?.unlockButtonText || 'Unlock Full Access';
    },
    containerStyles() {
      if (this.backgroundAttachment) {
        return {
          backgroundImage: `url(${this.backgroundAttachment.url})`,
          backgroundPosition: 'top right',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
        };
      }
      return {};
    },
    iconName() {
      return this.questionsRemaining > 0 ? 'help-outline' : 'lock';
    },
    isAddonPurchaseOrder() {
      const addonRootPurchaseOrders = this.$store.getters['purchaseOrders/rootAddon'];
      return addonRootPurchaseOrders.map(po => po.id).includes(this.jsonConfig.purchaseOrderId);
    },
    jsonConfig() {
      return this.config?.config;
    },
    questionsText() {
      return this.jsonConfig?.questionsRemainingText || 'Questions Remaining Today';
    },
  },
  mounted() {
    if (this.jsonConfig?.backgroundAttachmentId) {
      const params = { ids: [this.jsonConfig.backgroundAttachmentId] };
      this.$store.dispatch('attachments/fetch', params);
    }
  },
  methods: {
    handleActionButtonClick() {
      const analyticParams = {
        dashboard: this.dashboard,
        widget: this.config,
      };
      if (this.questionsRemaining > 0) {
        analyticParams.destination = 'Category Type';
        if (this.jsonConfig?.navigationItemId) {
          const navigationItem = this.$store.getters['navigationItems/navigationItems'][this.jsonConfig.navigationItemId];
          this.$router.push({
            name: 'categories#flashcard',
            params: {
              categoryId: 'all',
            },
            query: {
              nav: navigationItem?.query,
            },
          });
        } else {
          let categoryTypeId;
          if (this.jsonConfig.categoryTypeIds && this.jsonConfig.categoryTypeIds.length > 0) {
            const list = this.jsonConfig.categoryTypeIds;
            const index = Math.floor((Math.random() * list.length));
            categoryTypeId = list[index];
          } else {
            categoryTypeId = this.jsonConfig.categoryTypeId;
          }
          const category = this.$store.getters['categories/all']
            .find(cat => cat.categoryTypeId === categoryTypeId);
          this.$router.push({
            name: 'categories#flashcard',
            params: {
              categoryId: category.id,
            },
          });
        }
      } else {
        const source = { type: 'Rate Limit Widget' };
        if (this.isAddonPurchaseOrder) {
          analyticParams.destination = 'Addon Upgrade Screen';
          const catalogPage = this.$store.getters['catalog/pageList'].find(page => page.purchaseOrderId === this.jsonConfig.purchaseOrderId);
          this.$store.dispatch('ui/toggleCatalogModal', { show: true, source, catalogPageId: catalogPage.id });
        } else {
          analyticParams.destination = 'Upgrade Screen';
          this.$store.dispatch('ui/toggleUpsellModal', { show: true, source });
        }
      }
      this.$analytics.events.selectedRateLimitWidget(analyticParams);
    },
  },
};
</script>

<style lang="scss" scoped>
.rate-limit-widget-component {
  @include shadowed;
  align-items: flex-start;
  border-bottom: 4px solid #001C74;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-weight: $semi-bold;
  height: rem-calc(112);
  justify-content: space-evenly;
  margin: rem-calc(32) 0;
  overflow: hidden;
  width: 100%;
  // flex: 1;
  // margin: 0;

  .action-text {
    .questions-remaining {
      display: inline-block;
      font-size: rem-calc(32);
      margin-left: rem-calc(16);
      margin-right: rem-calc(4);
    }

    .questions-text {
      font-size: rem-calc(14);
    }
  }

  .action-button {
    align-items: center;
    background-color: #00B46D;
    border-radius: 28px;
    border: none;
    color: #ffffff;
    display: flex;
    font-size: rem-calc(12);
    font-weight: $semi-bold;
    margin-left: rem-calc(16);
    padding: 10px 14px;

    &.no-credits-left {
      background-color: #E98626;
    }

    .button-icon {
      margin-right: 4px;
      width: 12px;
    }
  }
}
</style>
